import * as React from 'react';
import PropTypes from 'prop-types';
import colors from '@strava/ui/colors';

const FistBumpWithDashesIconUnfilled = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={true}
  >
    <path
      d="M8.97755 5.12694L8.02246 6.08203L10.0224 8.08201L10.9775 7.12692L8.97755 5.12694Z"
      fill={color}
    />
    <path
      d="M15.0224 5.12697L13.0225 7.12695L13.9776 8.08204L15.9775 6.08206L15.0224 5.12697Z"
      fill={color}
    />
    <path d="M12.6748 4H11.3252V7H12.6748V4Z" fill={color} />
    <path
      d="M10.5 10.4297H9.52729L9.05659 8.54789L6.72069 7.96389C6.58009 7.90479 6.28909 7.80469 5.93749 7.80469C5.26559 7.80469 4.71779 8.15919 4.41409 8.76949L2.51569 12.0923L0.121094 13.2891L2.66989 19.024L5.15919 17.7794H7.99999C10.2803 17.7794 10.6436 16.3185 10.6582 16.256L10.6748 14.8468C10.9902 14.4025 11.1064 13.8492 11.1494 13.4845C11.7637 12.983 11.9121 12.1823 11.7685 11.5724C11.6064 10.8888 11.0976 10.4298 10.4999 10.4298L10.5 10.4297ZM1.87889 13.9199L2.64829 13.5349L4.14459 16.7778L3.33009 17.185L1.87889 13.9199ZM10.1982 12.501L9.82809 12.6885L9.82519 13.1021C9.82319 13.3399 9.74709 13.9029 9.52249 14.127L9.32519 14.3248V15.9718C9.24509 16.1012 8.94919 16.4298 7.99999 16.4298H5.47139L3.73789 12.6728L5.60339 9.40629C5.65609 9.30229 5.79189 9.02399 6.19809 9.20809L7.94319 9.66119L8.13529 10.4298H6.49989V11.7794H10.4179C10.4501 11.8429 10.4872 11.9742 10.4628 12.1295C10.4355 12.3019 10.3466 12.4269 10.1982 12.5011V12.501Z"
      fill={color}
    />
    <path
      d="M21.4843 12.0923L19.6034 8.80269C19.2821 8.15909 18.7343 7.80469 18.0624 7.80469C17.7108 7.80469 17.4198 7.90479 17.2792 7.96389L14.9433 8.54789L14.4726 10.4297H13.4999C12.9022 10.4297 12.3935 10.8887 12.2313 11.5723C12.0877 12.1822 12.2362 12.9829 12.8504 13.4844C12.8934 13.8491 13.0096 14.4024 13.325 14.8467V16.1045L13.3416 16.2559C13.3562 16.3184 13.7195 17.7793 15.9998 17.7793H18.8406L21.3299 19.0239L23.8787 13.289L21.4842 12.0922L21.4843 12.0923ZM14.6747 15.9819V14.3247L14.4774 14.1269C14.2528 13.9028 14.1766 13.3398 14.1747 13.1044V12.6874L13.8017 12.5009C13.6533 12.4267 13.5644 12.3017 13.5371 12.1293C13.5127 11.974 13.5498 11.8427 13.582 11.7792H17.5V10.4296H15.8646L16.0567 9.66099L17.6641 9.25909L17.793 9.21219C18.2041 9.02369 18.3438 9.30159 18.4141 9.43929L20.2616 12.672L18.5302 16.4296H16C15.0293 16.4296 14.7412 16.0858 14.6748 15.9818L14.6747 15.9819ZM20.6698 17.185L19.8564 16.7783L21.351 13.5346L22.1209 13.9199L20.6697 17.185H20.6698Z"
      fill={color}
    />
  </svg>
);

FistBumpWithDashesIconUnfilled.defaultProps = {
  color: colors.O50_STRAVA_ORANGE,
  size: 24
};
FistBumpWithDashesIconUnfilled.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};

export default FistBumpWithDashesIconUnfilled;
